import React from "react"
import moment from "moment"
import { get } from "lodash"
const RaDateField = ({ record, source, format = "DD-MMM-YYYY" }) => {
  const myDate = get(record, source, "")
  return <span>{moment(myDate).format(format)}</span>
}
export default RaDateField
